<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              Transportadora
              <v-btn depressed small color="error" v-on:click="logout()" class="btn-logout">
                <v-icon>exit_to_app</v-icon>Sair
              </v-btn>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-row no-gutters v-if="transportadora">
                <v-col :md="12" :sm="12" :xs="12" cols="12">
                  <strong class="info-text">
                    Razão Social:
                    <em>{{ transportadora.razaosocial }}</em>
                  </strong>
                </v-col>
                <v-col :md="12" :sm="12" :xs="12" cols="12" class="mt-2 text-md-left">
                  <strong class="info-text">
                    CNPJ:
                    <em>{{ transportadora.cnpj | cnpj }}</em>
                  </strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <FormConsultaPendencias />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import FormConsultaPendencias from "@/views/transportes/consulta-pendencias/FormConsultaPendencias";
import { mapState } from "vuex";

export default {
  metaInfo: {
    title: "Consulta de Pendências - Central de Serviços"
  },
  components: {
    FormConsultaPendencias
  },
  data() {
    return {
      transportadora: null
    };
  },
  methods: {
    getCurrentTransportadora() {
      this.transportadora =
        TransportadoraAuthService.currentTransportadoraValue;
    },
    logout() {
      TransportadoraAuthService.logout();
    }
  },
  mounted() {
    this.getCurrentTransportadora();
  }
};
</script>
